import React from "react";
import Image from "next/image";
import logo from "../../public/brand/selong-belanak-wordmark.png";

const SelongBelanakLogoFull = (props) => (
  <Image src={logo} alt="Selong Belanak Logo" unoptimized {...props} />
);

export default SelongBelanakLogoFull;
